import React from 'react';
import { TOKENOMICS, formatLilape, PRESALE_STAGES, getCurrentStage } from './config/gameConfig';
import { LILAPE_JETTON_ADDRESS } from './config';

export const TokenomicsPage = () => {
  const currentStage = getCurrentStage();

  return (
    <div style={{ padding: '0 16px 100px' }}>
      {/* Header */}
      <div className="page-header">
        <div className="page-header-icon" style={{ background: 'linear-gradient(135deg, #8B5CF6, #EC4899)' }}>📊</div>
        <div>
          <div className="page-title">Tokenomics</div>
          <div className="page-subtitle">LILAPE Token Economics</div>
        </div>
      </div>

      {/* Key Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 16 }}>
        <div className="stat-card">
          <div className="stat-value">420T</div>
          <div className="stat-label">Total Supply</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">0%</div>
          <div className="stat-label">Tax Fee</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">50%</div>
          <div className="stat-label">Burn Rate</div>
        </div>
      </div>

      {/* Distribution */}
      <div style={{
        background: 'var(--bg-card)',
        borderRadius: 16,
        padding: 16,
        border: '1px solid var(--border-color)',
        marginBottom: 16,
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14, color: '#fff' }}>
          📊 Token Distribution
        </div>

        {TOKENOMICS.distribution.map((item, i) => (
          <div key={i} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>{item.icon}</span>
                <span style={{ fontSize: 13, color: '#fff' }}>{item.name}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{formatLilape(item.amount)}</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: item.color }}>{item.percentage}%</span>
              </div>
            </div>
            <div style={{ height: 6, background: 'rgba(255,255,255,0.1)', borderRadius: 3, overflow: 'hidden' }}>
              <div style={{
                height: '100%',
                width: `${item.percentage}%`,
                background: item.color,
                borderRadius: 3,
              }} />
            </div>
          </div>
        ))}
      </div>

      {/* Current Presale Stage */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(245,158,11,0.1), rgba(239,68,68,0.05))',
        borderRadius: 16,
        padding: 16,
        border: '1px solid rgba(245,158,11,0.3)',
        marginBottom: 16,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#F59E0B' }}>
            🚀 Presale Stage {currentStage.stage}
          </div>
          <div style={{
            padding: '4px 10px',
            borderRadius: 20,
            background: 'rgba(16,185,129,0.2)',
            border: '1px solid rgba(16,185,129,0.4)',
            fontSize: 11,
            fontWeight: 700,
            color: '#10B981',
          }}>
            ACTIVE
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
          <div style={{ textAlign: 'center', padding: 12, background: 'rgba(0,0,0,0.2)', borderRadius: 10 }}>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', marginBottom: 4 }}>RATE</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#FFD700' }}>1 TON = {currentStage.rateLabel}</div>
          </div>
          <div style={{ textAlign: 'center', padding: 12, background: 'rgba(0,0,0,0.2)', borderRadius: 10 }}>
            <div style={{ fontSize: 10, color: 'var(--text-muted)', marginBottom: 4 }}>DISCOUNT</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: '#10B981' }}>{currentStage.discount}% OFF</div>
          </div>
        </div>

        <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'center' }}>
          Listing price: 1 TON = 2.5B LILAPE
        </div>
      </div>

      {/* All Stages */}
      <div style={{
        background: 'var(--bg-card)',
        borderRadius: 16,
        padding: 16,
        border: '1px solid var(--border-color)',
        marginBottom: 16,
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: '#fff' }}>
          📈 All Presale Stages
        </div>

        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 8 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '50px 1fr 60px 60px', gap: 8, padding: '0 0 8px', borderBottom: '1px solid var(--border-color)' }}>
            <span>Stage</span>
            <span>Rate</span>
            <span style={{ textAlign: 'right' }}>Discount</span>
            <span style={{ textAlign: 'right' }}>Status</span>
          </div>
        </div>

        {PRESALE_STAGES.map((stage, i) => (
          <div key={i} style={{
            display: 'grid',
            gridTemplateColumns: '50px 1fr 60px 60px',
            gap: 8,
            padding: '10px 0',
            borderBottom: i < PRESALE_STAGES.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
            opacity: stage.status === 'active' ? 1 : 0.6,
          }}>
            <span style={{ fontWeight: 700, color: stage.status === 'active' ? '#FFD700' : '#fff' }}>
              {stage.stage}
            </span>
            <span style={{ color: '#fff' }}>1 TON = {stage.rateLabel}</span>
            <span style={{ textAlign: 'right', color: '#10B981' }}>
              {stage.discount > 0 ? `${stage.discount}%` : 'List'}
            </span>
            <span style={{
              textAlign: 'right',
              fontSize: 10,
              color: stage.status === 'active' ? '#10B981' : stage.status === 'listing' ? '#F59E0B' : 'var(--text-muted)',
            }}>
              {stage.status === 'active' ? '● Active' : stage.status === 'listing' ? '○ Listing' : '○ Soon'}
            </span>
          </div>
        ))}
      </div>

      {/* Burn Mechanics */}
      <div style={{
        background: 'linear-gradient(135deg, rgba(239,68,68,0.1), rgba(245,158,11,0.05))',
        borderRadius: 16,
        padding: 16,
        border: '1px solid rgba(239,68,68,0.3)',
        marginBottom: 16,
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: '#EF4444' }}>
          🔥 Burn Mechanism
        </div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
          <strong>50%</strong> of all game house edge is <strong style={{ color: '#EF4444' }}>burned forever</strong>.
          <br /><br />
          More players = More burns = Increasing scarcity = Higher value
        </div>
        <div style={{
          marginTop: 12,
          padding: 10,
          background: 'rgba(0,0,0,0.2)',
          borderRadius: 8,
          fontSize: 12,
          color: 'var(--text-muted)',
        }}>
          House Edge: 10-15% → 50% burned, 30% to Prize Pool, 20% Treasury
        </div>
      </div>

      {/* Contract */}
      <div style={{
        background: 'var(--bg-card)',
        borderRadius: 16,
        padding: 16,
        border: '1px solid var(--border-color)',
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: '#fff' }}>
          📜 Smart Contract
        </div>
        <div style={{
          padding: 12,
          background: 'rgba(0,0,0,0.3)',
          borderRadius: 8,
          fontFamily: 'monospace',
          fontSize: 10,
          color: '#10B981',
          wordBreak: 'break-all',
          marginBottom: 12,
        }}>
          {LILAPE_JETTON_ADDRESS}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <a
            href={`https://tonviewer.com/${LILAPE_JETTON_ADDRESS}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: 8,
              background: 'rgba(59,130,246,0.15)',
              border: '1px solid rgba(59,130,246,0.3)',
              color: '#3B82F6',
              textDecoration: 'none',
              textAlign: 'center',
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Tonviewer →
          </a>
          <a
            href={`https://tonscan.org/address/${LILAPE_JETTON_ADDRESS}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: 8,
              background: 'rgba(139,92,246,0.15)',
              border: '1px solid rgba(139,92,246,0.3)',
              color: '#8B5CF6',
              textDecoration: 'none',
              textAlign: 'center',
              fontSize: 12,
              fontWeight: 600,
            }}
          >
            Tonscan →
          </a>
        </div>
      </div>
    </div>
  );
};

export default TokenomicsPage;
